import { render, staticRenderFns } from "./CostSupervise.vue?vue&type=template&id=6c8eed0b&scoped=true&"
import script from "./CostSupervise.vue?vue&type=script&lang=ts&"
export * from "./CostSupervise.vue?vue&type=script&lang=ts&"
import style0 from "./CostSupervise.vue?vue&type=style&index=0&id=6c8eed0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8eed0b",
  null
  
)

export default component.exports